import axios from 'axios'
import { GERAR_QRCODE_SICOOB_ENCOMENDA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

// gera (ou regera) o QR Code PIX Sicoob de uma encomenda já criada -- equivalente ao
// gerarQrcodePixSicoobPedidoExistente da reserva, mas pelo endpoint da encomenda
export default function gerarQrcodePixSicoobEncomenda (idEncomenda, empresaId) {
  const url = `${URL}/encomendas/${idEncomenda}/gerar-qrcode-sicoob?empresaId=${empresaId}`;
  return dispatch => axios.post(url, {}, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: GERAR_QRCODE_SICOOB_ENCOMENDA,
        payload: response
      })
  );
}
